import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import learnit from '../assets/built-to-learn.webp'
import financialIndependence from '../assets/financial-independence.webp'
import gimmick from '../assets/gimme-yo-money.webp'
import SST from '../assets/SST.webp'
import HillsToHome from '../assets/HillsToHome.webp'
import TiltThis from './Tilt'
import Paper from '@material-ui/core/Paper'
import GitHubIcon from '@material-ui/icons/GitHub'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import IconButton from '@material-ui/core/IconButton'
import React from 'react'
import MIT from '../assets/MIT.webp'

const useStyles = makeStyles((theme) => ({
    projectImg: {
        display: 'flex',
        justifyContent: 'center',
    },

    rightSide: {
        textAlign: 'right',
    },

    leftSide: {
        textAlign: 'left',
    },

    projectDesc: {
        backgroundColor: 'rgb(35, 53, 84)',
        color: '#ccd6f6',
        textAlign: 'left',
        padding: '1rem',
    },

    icon: {
        color: '#ccd6f6',
    },

    featuredProject: {
        color: '#64ffda',
        textAlign: 'right',
        fontFamily: 'Space Mono',
    },

    featuredProjectPro: {
        color: '#64ffda',
        textAlign: 'left',
        fontFamily: 'Space Mono',
    },

    leftSideContain: {
        display: 'flex',
        justifyContent: 'flex-start',
    },
}))

export default function Projects() {
    const classes = useStyles()
    // const photo = require('./assets/peru.webp')

    function LinkRow({ githubLink, liveLink }) {
        return (
            <React.Fragment>
                <div className={classes.rightSide}>
                    <IconButton
                        onClick={(event) => (window.location.href = githubLink)}
                    >
                        {githubLink ? (
                            <GitHubIcon className={classes.icon} />
                        ) : null}
                    </IconButton>
                    <IconButton
                        onClick={(event) => (window.location.href = liveLink)}
                    >
                        <ExitToAppIcon className={classes.icon} />
                    </IconButton>
                </div>
            </React.Fragment>
        )
    }
    return (
        <Grid
            container
            // spacing={3}
            direction="column"
            justify="center"
            alignItems="center"
            className="primary-background"
        >
            <Grid
                className="projects"
                container
                item
                xs={12}
                spacing={6}
                direction="row" //when mobile switch to columns
                justify="center"
                alignItems="center"
            >
                <Grid item xs={8}>
                    <h1>Things I've Built</h1>
                    <hr />
                </Grid>
                <Grid item xs={5} className={classes.projectImg}>
                    <TiltThis
                        imageURL={learnit}
                        liveLink="https://built-to-learn.herokuapp.com/"
                    />
                </Grid>
                <Grid item xs={12} md={5}>
                    <div>
                        <h3 className={classes.featuredProject}>
                            Featured Project
                        </h3>
                        <h2 className={classes.rightSide}>Learn It</h2>
                        <Paper className={classes.projectDesc}>
                            Learn It is a live stream teaching platform that
                            brings the best teachers on the web to anyone with a
                            computer. Learn It was created with the intention
                            that rock star teachers should be paid like super
                            stars.
                        </Paper>
                        <p className={classes.rightSide}>
                            PostgresSQL | Express | React | Node.js | WebRTC |
                            Amazon S3 | Stripe
                        </p>
                        <LinkRow
                            githubLink="https://github.com/Built-To-Learn/learn.it"
                            liveLink="https://built-to-learn.herokuapp.com/"
                        />
                    </div>
                </Grid>
                <Grid xs={8} md={5} className={classes.projectImg}>
                    <TiltThis
                        imageURL={financialIndependence}
                        liveLink="https://finfreedom.onrender.com"
                    />
                </Grid>
                <Grid item xs={12} md={5}>
                    <div>
                        <h3 className={classes.featuredProject}>
                            Featured Project
                        </h3>
                        <h2 className={classes.rightSide}>
                            Financial Freedom Dashboard
                        </h2>
                        <Paper className={classes.projectDesc}>
                            The financial freedom dashboard calculates how much
                            money is required to invest on a monthly basis in
                            order to become financially independent.
                        </Paper>
                        <p className={classes.rightSide}>
                            Express | React | Node.js | Redux
                        </p>
                        <LinkRow
                            githubLink="https://github.com/msze400/Financial-Independence-App"
                            liveLink="https://finfreedom.onrender.com"
                        />
                    </div>
                </Grid>
                <Grid item xs={8} md={5} className={classes.projectImg}>
                    <TiltThis
                        imageURL={gimmick}
                        liveLink="https://gimmicks.onrender.com"
                    />
                </Grid>
                <Grid item xs={12} md={5}>
                    <div>
                        <h3 className={classes.featuredProject}>
                            Featured Project
                        </h3>
                        <h2 className={classes.rightSide}>
                            Gimme Yo Money Gimmicks
                        </h2>
                        <Paper className={classes.projectDesc}>
                            Gimme Yo Money Gimmicks is an e-commerce store that
                            allows users to buy gag gifts for their loved ones.
                        </Paper>
                        <p className={classes.rightSide}>
                            PostgresSQL | Express | React | Node.js | Material
                            UI
                        </p>
                        <LinkRow
                            githubLink="https://github.com/Graceshopper-Gimmick/Grace-Shopper-Gimmick/tree/main/fs-app-template"
                            liveLink="https://gimmicks.onrender.com"
                        />
                    </div>
                </Grid>
                <Grid item xs={8}>
                    <h1>Professional Work</h1>
                    <hr />
                </Grid>
                <Grid item xs={12} md={5}>
                    <div>
                        <h3 className={classes.featuredProjectPro}>
                            Featured Project
                        </h3>
                        <h2 className={classes.leftSide}>
                            Sinfully Sweet Treats
                        </h2>
                        <Paper className={classes.projectDesc}>
                            Sinfully Sweet Treats is a New Jersey based home
                            cottage dessert bakery business that sells custom
                            made treats directly to customers.
                        </Paper>
                        <p className={classes.leftSide}>
                            Tailwind | React | Typescript
                        </p>
                        <div className={classes.leftSideContain}>
                            <LinkRow
                                githubLink="https://github.com/msze400/Sinfully-Sweet-Treats"
                                liveLink="http://sstreatsbyamanda.com/"
                            />
                        </div>
                    </div>
                </Grid>
                <Grid item xs={5} className={classes.projectImg}>
                    <TiltThis
                        imageURL={SST}
                        liveLink="http://sstreatsbyamanda.com"
                    />
                </Grid>
                <Grid item xs={12} md={5}>
                    <div>
                        <h3 className={classes.featuredProjectPro}>
                            Featured Project
                        </h3>
                        <h2 className={classes.leftSide}>Hill to Home</h2>
                        <Paper className={classes.projectDesc}>
                            Hill's to Home is eCommerce platform where customers
                            can buy prescription or non-prescription based for
                            their furry friends!
                        </Paper>
                        <p className={classes.leftSide}>
                            Angular | Typescript | Bootstrap
                        </p>
                        <div className={classes.leftSideContain}>
                            <LinkRow
                                // githubLink="https://github.com/msze400/Sinfully-Sweet-Treats"
                                liveLink="https://hillstohome.com/login"
                            />
                        </div>
                    </div>
                </Grid>
                <Grid item xs={5} className={classes.projectImg}>
                    <TiltThis
                        imageURL={HillsToHome}
                        liveLink="https://hillstohome.com/login"
                    />
                </Grid>
                <Grid item xs={12} md={5}>
                    <div>
                        <h3 className={classes.featuredProjectPro}>
                            Featured Project
                        </h3>
                        <h2 className={classes.leftSide}>
                            MIT Lincoln Lab Projects
                        </h2>
                        <Paper className={classes.projectDesc}>
                            Coding up a ton of things that I can't mention here
                            but they involve dealing with outer-space, front-end
                            development, backend development, and much more.
                        </Paper>
                        <p className={classes.leftSide}>
                            Svelte | React | ExtJS | PostgresSQL | PostgREST |
                            Python | FastAPI | Docker | Maven | Open Layers |
                            Apex Charts | Jenkins
                        </p>
                        <div className={classes.leftSideContain}>
                            <LinkRow
                                // githubLink="https://github.com/msze400/Sinfully-Sweet-Treats"
                                liveLink="https://www.ll.mit.edu/r-d/homeland-protection/artificial-intelligence-software-architectures-and-algorithms"
                            />
                        </div>
                    </div>
                </Grid>
                <Grid item xs={5} className={classes.projectImg}>
                    <TiltThis
                        imageURL={MIT}
                        liveLink="https://www.ll.mit.edu/r-d/homeland-protection/artificial-intelligence-software-architectures-and-algorithms"
                    />
                </Grid>
            </Grid>
            <div style={{ height: '10vh' }} />
        </Grid>
    )
}
